//@flow
import BaseCategoriesCollection from './baseCategoriesCollection';

export default class MarketingCategoriesCollection extends BaseCategoriesCollection {
  __primaryCategoryUrlKey() {
    return 'marketing';
  }
}
